import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { useDispatch } from 'react-redux'
import { Button, Card, CardContent, Dialog, DialogActions, DialogContent, Typography } from '@mui/material'
import UserAction from '../user/actions/UserAction'
import { keys, snakeCase } from 'lodash'
import { CardTitle } from 'components/card/NewCard'
import SimpleInput from 'components/forms/SimpleInput'
import ToastrAction from 'toastr/actions/ToastrAction'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import { DEFAULT_AQUASYS_EMAIL } from 'components/sieau/SieauConstants'

const MAX_LOGIN_LENGTH = 50
const getLimitedLoginLength = (conventionalName = '') => MAX_LOGIN_LENGTH - conventionalName.length - 1
const getLimitedLogin = (login, conventionalName) => login.slice(0, getLimitedLoginLength(conventionalName))

const DuplicateModuleDialog = ({
    moduleToDuplicate = {},
    onClose = () => {},
}) => {
    const defaultNewModuleName = getLimitedLogin(`${i18n.copyOf} ${moduleToDuplicate.name}`, moduleToDuplicate.conventionalName)
    const [newModuleName, setNewModuleName] = useState(defaultNewModuleName)

    const dispatch = useDispatch()

    useEffect(() => {
        if (newModuleName !== defaultNewModuleName) {
            setNewModuleName(defaultNewModuleName)
        }
    }, [moduleToDuplicate])

    const handleClose = () => {
        onClose()
        dispatch(ToastrAction.success(i18n.moduleSuccessfullySaved))
        dispatch(UserAction.fetchApplicativeUsers())
        dispatch(UserAction.getUsersModulesAccess())
    }

    const onValidate = () => {
        dispatch(UserAction.duplicateUser(moduleToDuplicate.login, {
            login: `${moduleToDuplicate.conventionalName}_${snakeCase(newModuleName)}`,
            email: DEFAULT_AQUASYS_EMAIL,
            name: newModuleName,
            isApplicative: true,
        }, true, handleClose))
    }

    return (
        <Dialog
            maxWidth='lg'
            open={keys(moduleToDuplicate).length}
        >
            <DefaultDialogTitle title={i18n.duplicatingModule} onClose={onClose} />
            <DialogContent>
                <Card variant='newCard'>
                    <CardTitle title={<Typography variant='cardTitle'>{i18n.moduleDescription}</Typography>} />
                    <CardContent>
                        <SimpleInput
                            title={i18n.name}
                            value={newModuleName}
                            onChange={setNewModuleName}
                            maxLength={getLimitedLoginLength(moduleToDuplicate.conventionalName)}
                        />
                    </CardContent>
                </Card>
            </DialogContent>
            <DialogActions>
                <Button onClick={onValidate} variant='contained' color='primary' disabled={!newModuleName} >
                    {i18n.validate}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

DuplicateModuleDialog.propTypes = {
    moduleToDuplicate: PropTypes.shape({}),
    onClose: PropTypes.func,
}

export default DuplicateModuleDialog